import styled from "styled-components";

const StyledPedidoEmOver = styled.div`
  .baseModal {
    height: 125px;
  }

  .container-action-buttons-pedido-over {
    display: flex;
    float: right;
    gap: .5rem;

    .button{
      width: 80px !important;
    }
  }

  .labelVision {
    position: fixed;
    z-index: 1502;
    width: 100%;
    padding-right: 26px;
  }

  .alertMessage {
    padding-bottom: 10px;
  }
`;

export default StyledPedidoEmOver;
